<div class="custom-table overflow-x-auto">
	<table class="mat-elevation-z8 bg-transparent w-full relative">
		<thead class="bg-light">
			<tr class="border-b-[1px] border-secondry-color-Gray">
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[24px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.OFFER_NAME' | translate }}
				</td>

				<td
					class="text-center text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'GENERAL_LABELS.DATE' | translate }}
				</td>
				<td
					class="text-center text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.TYPE' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.AMOUNT' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'PRODUCT_PROMO.USAGE' | translate }}
				</td>

				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ 'OFFERS.OFFERS_LIST.STATE' | translate }}
				</td>
				<td
					class="text-font-14 leading-[22px] text-medium-gray py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				></td>
			</tr>
		</thead>
		<tbody class="bg-grey-background">
			<tr
				*ngFor="
					let offer of offers
						| paginate
							: {
									itemsPerPage: productPromoCodeFilter?.paging?.pageSize,
									currentPage: productPromoCodeFilter?.paging?.pageNumber,
									totalItems: totalCount
							  }
				"
				class="border-b-[1px] border-secondry-color-Gray"
			>
				<td
					routerLink="/layout/store/products/view-product-promocode/{{
						offer.id
					}}"
					class="cursor-pointer text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[24px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<div class="flex items-center">
						<img
							class="w-[56px] h-[56px] rounded-full"
							[src]="attachmentLink + offer.offerImageEn"
							alt=""
						/>
						<div>
							<p class="inline-block text-dark-grey whitespace-nowrap">
								<span *ngIf="translate.currentLang == 'en'">
									<span class="text-dark-grey">
										{{ offer?.offerNameEn | slice : 0 : 15 }}
										{{
											offer?.offerNameEn?.length
												? offer.offerNameEn.length > 15
													? '...'
													: ''
												: null
										}}
									</span>
								</span>
								<span *ngIf="translate.currentLang == 'ar'">
									<span class="text-dark-grey">
										{{ offer?.offerNameAr | slice : 0 : 15 }}
										{{
											offer?.offerNameAr?.length
												? offer.offerNameAr.length > 15
													? '...'
													: ''
												: null
										}}
									</span>
								</span>
							</p>
							<img
								class="inline-block mx-12px"
								*ngIf="offer?.isLabeled"
								src="./assets/images/tag.svg"
								alt=""
							/>
						</div>
					</div>
				</td>

				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
				>
					<h1 class="text-font-16 text-dark-grey max-mobile:text-font-12 m-0">
						{{ offer?.startDate | date : 'dd/MM/yyyy' }}
						{{ 'GENERAL.TO' | translate }}
						{{ offer?.endDate | date : 'dd/MM/yyyy' }}
					</h1>
				</td>
				<td
					*ngIf="offer?.type"
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[30px] max-mobile:px-padding-mobile-14 whitespace-nowrap text-center"
				>
					{{ 'PRODUCT_PROMO.' + offerType[offer.type - 1].name | translate }}
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[15px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<ng-container *ngIf="offer?.type == 1">
						<p class="mb-0">
							{{ offer?.offerAmount }}
							{{
								translate?.currentLang == 'en'
									? offer?.currency?.name?.en
									: offer?.currency?.name?.ar
							}}
						</p>
						<p>
							{{ 'OFFERS.OFFERS_LIST.MIN' | translate }}
							{{ offer?.minimumCheckoutAmount
							}}{{
								translate?.currentLang == 'en'
									? offer?.currency?.name?.en
									: offer?.currency?.name?.ar
							}}
						</p>
					</ng-container>
					<ng-container *ngIf="offer?.type == 2">
						<p class="mb-0">{{ offer?.offerAmount }} %</p>
						<p>
							{{ 'OFFERS.OFFERS_LIST.UP_TO' | translate }}
							{{ offer?.uptoAmount }}
							{{
								translate?.currentLang == 'en'
									? offer?.currency?.name?.en
									: offer?.currency?.name?.ar
							}}
						</p>
					</ng-container>
					<ng-container *ngIf="offer?.type == 3">
						<p class="mb-0">
							{{ 'PRODUCT_PROMO.BUY_NUM' | translate }} {{ offer?.buyCount }}
						</p>
						<p>
							{{ 'PRODUCT_PROMO.GET_NUM' | translate }}
							{{ offer?.getCount }}
						</p>
					</ng-container>
				</td>

				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[15px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					{{ offer?.usageCount }}
					{{ 'OFFERS.OFFERS_LIST.OF' | translate }} {{ offer?.maxUsageCount }}
				</td>

				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<p
						*ngIf="offer?.isActive"
						class="inline-block text-font-16 text-[#00BA88] mb-0 ltr:ml-[16px] rtl:mr-[16px]"
					>
						{{ 'OFFERS.OFFERS_LIST.ACTIVE' | translate }}
					</p>
					<p
						*ngIf="!offer?.isActive"
						class="inline-block text-font-16 text-red-error mb-0 ltr:ml-[16px] rtl:mr-[16px]"
					>
						{{ 'OFFERS.OFFERS_LIST.INACTIVE' | translate }}
					</p>
				</td>
				<td
					class="text-font-16 leading-[22px] text-[#4E4B66] bg-off-white py-[14px] px-[12px] max-mobile:px-padding-mobile-14 whitespace-nowrap"
				>
					<span
						class="inline-block max-mobile:w-[20px] w-[16px] text-end ltr:mr-[15px] rtl:ml-[15px]"
					>
						<button
							routerLink="/layout/store/products/view-product-promocode/{{
								offer.id
							}}"
						>
							<img
								class="inline-block"
								[src]="'assets/images/view.svg'"
								alt=""
							/>
						</button>
					</span>
				</td>
			</tr>
		</tbody>
	</table>
</div>
